import { FormIPSubnetField } from '@ipfabric/ui-components/FormIPSubnetField/FormIPSubnetField';
import type {
  IPSubnetInputValue,
  IPSubnetInputValueOrDraft,
} from '@ipfabric/ui-components/IPSubnetInput/IPSubnetInput.types';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { ipCidrListSchemaZ } from '../../utils/validation';

export const ipScopeInclude: FormSnippet<
  DiscoverySettingsObject,
  { ipScopeInclude: IPSubnetInputValueOrDraft },
  { ipScopeInclude: IPSubnetInputValue }
> = {
  render: ({ form }) => (
    <FormIPSubnetField
      control={form.control}
      name='ipScopeInclude'
      label='Include in discovery'
      description='Use 0.0.0.0/0 to include everything'
      type='cidr'
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.ipScopeInclude = {
      ips: model.networks?.include ?? [],
    };
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.networks = {
      ...modelDraft.networks,
      include: transformedValues.ipScopeInclude.ips,
    };
  },
  schema: z.object({
    ipScopeInclude: ipCidrListSchemaZ,
  }),
};
